<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="'Products & Services Matches'"
        />
        <router-link :to="{ name: 'tool-list' }">
          <v-btn
            rounded
            large
            dark
            :color="'#424EC4'"
            >
            Back to All Products & Services
          </v-btn>
        </router-link>
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->
    <!-- Blog Details Start-->
    <section class="section section-blog pt-0 mt-3">
      <div :class="containerWidthClass" class="container-fluid px-xs-1 px-sm-1 px-md-5 px-lg-5 px-xl-5">
        <article class="container-boundary">
          <!-- Compare Matches Header -->
          <div class="row row-header w-100 m-0">
            <div class="col-12 p-0">
              <div class="row h-100 w-100 mt-0 ml-0">
                <div class="h-100 col-2 left-row-header">
                  <!-- Empty Div Space For Header -->
                </div>
                <div class="h-100 col-10">
                  <div class="row mt-1 w-100 h-100">
                    <div v-for="tool in items" class="col h-100 d-flex flex-column justify-content-center" :key="tool.id">
                      <div style="height: 50%;" class="d-flex justify-content-center align-items-center">
                        <img
                          :src="tool?.mainImage"
                          :alt="tool?.photoDescription"
                          class="tool-icon"
                        />
                      </div>
                      <div style="height: 50%;" class="d-flex justify-content-center align-items-center text-center text-content">
                        <div class="flex-container title-container">
                          <p class="m-0 clipped-text flex-center title-text">
                            {{ tool.toolCreatedBy }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Compare Matched Body Start -->
          
          <!-- Product & Service Title -->
          <div class="row row-body w-100 m-0">
            <div class="col-12 p-0">
              <div class="row h-100 w-100 mt-0 ml-0">
                <div class="h-100 col-2 d-flex justify-content-center align-items-center row-title text-content">
                  Tool Created By
                </div>
                <div class="h-100 col-10">
                  <div class="row w-100 h-100 mt-0 ml-0">
                    <div v-for="tool in items" class="col h-100 d-flex flex-column justify-content-center align-items-center text-center text-content" :key="tool.id">
                      {{ tool.title }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product & Service Website -->
          <div class="row row-body w-100 m-0">
            <div class="col-12 p-0">
              <div class="row h-100 w-100 mt-0 ml-0">
                <div class="h-100 col-2 d-flex justify-content-center align-items-center row-title text-content">
                  Website
                </div>
                <div class="h-100 col-10">
                  <div class="row w-100 h-100 mt-0 ml-0">
                    <div v-for="tool in items" class="col h-100 text-content clipped-website-text cell-padding-text" :key="tool.id">
                        <a target="_blank" :href="tool?.toolWebsite">{{ tool.toolCreatedBy }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product & Service Ease Of Use -->
          <div class="row row-body w-100 m-0">
            <div class="col-12 p-0">
              <div class="row h-100 w-100 mt-0 ml-0">
                <div class="h-100 col-2 d-flex justify-content-center align-items-center row-title text-content">
                  Ease Of Use
                </div>
                <div class="h-100 col-10">
                  <div class="row w-100 h-100 mt-0 ml-0">
                    <div v-for="tool in items" class="col h-100 d-flex flex-column justify-content-center align-items-center text-content" :key="tool.id">
                      {{ tool?.toolEaseOfUse }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product & Service Cost Model -->
          <div class="row row-body w-100 m-0">
            <div class="col-12 p-0">
              <div class="row h-100 w-100 mt-0 ml-0">
                <div class="h-100 col-2 d-flex justify-content-center align-items-center row-title text-content">
                  Cost Model
                </div>
                <div class="h-100 col-10">
                  <div class="row w-100 h-100 mt-0 ml-0">
                    <div v-for="tool in items" class="col h-100 d-flex flex-column justify-content-center align-items-center text-content" :key="tool.id">
                      {{ tool?.toolCostModel }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product & Service Typical Users -->
          <div class="row row-body w-100 m-0">
            <div class="col-12 p-0">
              <div class="row h-100 w-100 mt-0 ml-0">
                <div class="h-100 col-2 d-flex justify-content-center align-items-center row-title text-content">
                  Typical Users
                </div>
                <div class="h-100 col-10">
                  <div class="row w-100 h-100 mt-0 ml-0">
                    <div v-for="tool in items" class="col h-100 d-flex flex-column justify-content-center align-items-center text-content" :key="tool.id">
                      {{ tool?.toolTypicalUsers }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product & Service Description -->
          <div class="row row-body w-100 m-0">
            <div class="col-12 p-0">
              <div class="row h-100 w-100 mt-0 ml-0">
                <div class="h-100 col-2 d-flex justify-content-center align-items-center row-title text-content">
                  Description
                </div>
                <div class="h-100 col-10 mb-3">
                  <div class="row w-100 h-100 mt-0 ml-0">
                    <div v-for="tool in items" class="col h-100 d-flex flex-column justify-content-start align-items-center text-description" :key="tool.id">
                      {{ tool?.headLine }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product & Service Free Training Resource -->
          <div class="row row-body w-100 m-0">
            <div class="col-12 p-0">
              <div class="row h-100 w-100 mt-0 ml-0">
                <div class="h-100 col-2 d-flex justify-content-center align-items-center text-center row-title text-content">
                  Free Training Resources
                </div>
                <div class="h-100 col-10">
                  <div class="row w-100 h-100 mt-0 ml-0">
                    <div v-for="tool in items" class="col h-100 d-flex flex-column justify-content-center align-items-center" :key="tool.id">
                      <font-awesome-icon
                          v-if="tool?.toolFreeTrainingResourcesAvailable === 'true'"
                          class="pl-1"
                          size="lg"
                          :icon="['fas', 'check-circle']"
                        />
                        <font-awesome-icon
                          v-else
                          class="pl-1"
                          size="lg"
                          :icon="['fas', 'times-circle']"
                        />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product & Service Paid Training Resources -->
          <div class="row row-body w-100 m-0">
            <div class="col-12 p-0">
              <div class="row h-100 w-100 mt-0 ml-0">
                <div class="h-100 col-2 d-flex justify-content-center align-items-center text-center row-title text-content">
                  Paid Training Resources
                </div>
                <div class="h-100 col-10">
                  <div class="row w-100 h-100 mt-0 ml-0">
                    <div v-for="tool in items" class="col h-100 d-flex flex-column justify-content-center align-items-center" :key="tool.id">
                      <font-awesome-icon
                          v-if="tool?.toolPaidTraining === 'true'"
                          class="pl-1"
                          size="lg"
                          :icon="['fas', 'check-circle']"
                        />
                        <font-awesome-icon
                          v-else
                          class="pl-1"
                          size="lg"
                          :icon="['fas', 'times-circle']"
                        />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product & Service Related Certificates -->
          <div class="row row-body w-100 m-0">
            <div class="col-12 p-0">
              <div class="row h-100 w-100 mt-0 ml-0">
                <div class="h-100 col-2 d-flex justify-content-center align-items-center row-title text-content">
                  Related Certificates
                </div>
                <div class="h-100 col-10 mb-3">
                  <div class="row w-100 h-100 mt-0 ml-0">
                    <div v-for="tool in items" class="col h-100 d-flex flex-column justify-content-start align-items-center" :key="tool.id">
                      <b-list-group style="width: 100%;" v-if="tool?.toolRelatedCertifications?.certification.length > 0">
                        <b-list-group-item v-for="cert in tool?.toolRelatedCertifications?.certification" class="text-description" :key="cert">
                          {{ cert }}
                        </b-list-group-item>
                      </b-list-group>
                      <b-list-group style="width: 100%;" v-else>
                        <b-list-group-item class="text-description">None</b-list-group-item>
                      </b-list-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Product & Sevice Known Clients -->
          <div class="row row-body w-100 m-0">
            <div class="col-12 p-0">
              <div class="row h-100 w-100 mt-0 ml-0">
                <div class="h-100 col-2 d-flex justify-content-center align-items-center row-title text-content">
                  Known Clients
                </div>
                <div class="h-100 col-10 mb-3">
                  <div class="row w-100 h-100 mt-0 ml-0">
                    <div v-for="tool in items" class="col h-100 d-flex flex-column justify-content-start align-items-center" :key="tool.id">
                      <b-list-group style="width: 100%;" v-if="tool?.toolKnownClients?.knownClient.length > 0">
                        <b-list-group-item v-for="client in tool?.toolKnownClients?.knownClient" class="text-description" :key="client">
                          {{ client }}
                        </b-list-group-item>
                      </b-list-group>
                      <b-list-group style="width: 100%;" v-else>
                        <b-list-group-item class="text-description">None</b-list-group-item>
                      </b-list-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Compare Matched Body End -->
        </article>
      </div>
    </section>
    <!-- Blog Details Section End-->
  </div>
</template>
<script>
import { BFormInput } from 'bootstrap-vue';
import axios from 'axios';
import SocialShareBookmark from '../social-share-bookmark.vue';
import PageHeader from "../library/widgets/page-header.vue";
import PageHeaderTitleContent from "../library/widgets/page-header-title-content.vue";
import TitleTextContent from '../library/widgets/title-text-content.vue';
export default {
  name: 'tool-detail',
  components: {
    BFormInput,
    SocialShareBookmark,
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
  },
  props: {
    ids: Array,
  },
  data() {
    return {
      isLoading: false,
      query: '',
      items: [],
      comment: '',
      linkCopyText: 'Click to copy url link',
    };
  },
  async created() {
    //console.log('ids', this.ids);
    if (this.ids.length > 0) {
      const resourcesAsync = this.ids.map(async (id) => await this.getResource(id));
      this.items = await Promise.all(resourcesAsync);
    } else {
      this.$router.push({ path: 'tool-list' });
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    title() {
      return this.item?.title || 'Title';
    },
    description() {
      return this.item?.headLine || 'HeadLine';
    },
    containerWidthClass() {
      if(this.$vuetify.breakpoint.xs) {
        return "xs-width";
      }
      else if(this.$vuetify.breakpoint.sm) {
        return "sm-width";
      }
      else if(this.$vuetify.breakpoint.md) {
        return "md-width";
      }
      else {
        return "lg-xl-width";
      }
    }
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $('footer').outerHeight();
      $('.main-content').css('margin-bottom', footerHeight);
    },
    async getResource(id) {
      //console.log('Get Resource', id);
      return axios
        .get(`/api/resources/toolReviews/${id}`)
        .then((response) => {
          if (response.data.Items.length > 0) {
            /** Does an item exist for the query id */
            return response.data.Items[0];
            //console.log('Item', response.data);
            //console.log('ITems', this.items);
          } else {
            /** If no item exists with the id, redirect to list*/
            this.$router.push({ path: 'tool-list' });
          }
        })
        .catch((error) => {
          /** On error, redirect back to list */
          console.error(error);
          this.$router.push({ path: 'tool-list' });
        });
    },
    isBoolean(value) {
      var isBool = typeof value === 'boolean';
      var isBoolString = ['true', 'false'].includes(value);
      return isBool || isBoolString;
    },
    isBooleanTrue(value) {
      var isBool = typeof value === 'boolean';
      var isBoolString = ['true', 'false'].includes(value);
      return (isBool && value) || (isBoolString && value === 'true');
    },
  },
};
</script>
<style scoped>
.centered-link {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 125px;
}

.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tool-icon {
  object-fit: contain;
  height: 50px;
  display: block;
  margin: auto; /*optional centering of image*/
}

.title-container {
  height: 50px;
}

.flex-container {
  display: flex; /* establish flex container */
  flex-direction: column; /* make main axis vertical */
  justify-content: center; /* center items vertically, in this case */
  align-items: center; /* center items horizontally, in this case */
}

.flex-center {
  text-align: center; /* will center text in <p>, which is not a flex item */
}

.title-text {
  font-size: 1.2em;
  line-height: 1.2em;
}

.clipped-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.cell-item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.clipped-website-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.cell-padding-text {
  padding-top: 50px;
}

.container-boundary {
  border: 1px solid rgba(0, 0, 0, 0.20);
  min-width: 1400px;
}
.row-header {
  height: 200px;
  width: 100%;
}
.row-body {
  min-height: 150px;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.20);
}
.left-row-header {
  border-right: 1px solid rgba(0, 0, 0, 0.20);
}
.row-title {
  background-color: #E9ECF5;
  border-right: 1px solid rgba(0, 0, 0, 0.20);
}
.text-content {
  color: #272727;
  font-family: GeomGraphic;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.text-description {
  color: #000;
  font-family: Rajdhani;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.xs-width {
  max-width: 600px;
  overflow-x: auto;
  overflow-y: hidden;
}
.sm-width {
  max-width: 750px;
  overflow-x: auto;
  overflow-y: hidden;
}
.md-width {
  max-width: 1100px;
  overflow-x: auto;
  overflow-y: hidden;
}
.lg-xl-width {
  width: 100%;
}
</style>
